<iv-top-nav class="main-top-nav" *ngIf="isLoaded && !isHomePage"></iv-top-nav>
<router-outlet></router-outlet>
